import ModuleScene from './ModuleScene';

export default ModuleScene;
